import React from "react";
import { KPIS } from "../data";

// Render a sub-array like ["text", {ac: "accent text"}, ...]
function renderSub(parts) {
  return parts.map((p, i) =>
    typeof p === "string" ? (
      <React.Fragment key={i}>{p}</React.Fragment>
    ) : (
      <span key={i} className="ac">
        {p.ac}
      </span>
    ),
  );
}

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="prompt">
        <span className="sig">~ </span>
        <span className="sig">$</span>{" "}
        <span className="cmd">whoami --verbose</span>
        <span className="caret" />
      </div>

      <h1>
        <span className="first it">Bryson</span>
        <span className="it last">Nyamwange</span>
      </h1>

      <p className="role">
        <b>Software engineer</b> with <span className="ac">5+ years</span>{" "}
        designing, building and shipping scalable web &amp; backend systems.
        Strong on software architecture, data structures and algorithms, with a
        focus on{" "}
        <b>distributed systems, CI/CD automation and cloud infrastructure</b>.
        Passionate about accessible, efficient, user-centred software that
        solves complex problems at scale.
      </p>

      <div className="hero-meta">
        <span className="tag ok">
          <span className="gl">▸</span> Nairobi · Remote
        </span>
        <span className="tag">
          <span className="k">stack/</span>typescript · nestjs · aws · k8s ·
          postgres
        </span>
        <span className="tag">
          <span className="k">cv/</span>
          <a
            className="tag-link"
            href={process.env.PUBLIC_URL + "/assets/Nyamwange.pdf"}
            download
          >
            Nyamwange.pdf
          </a>
        </span>
        <span className="tag">
          <span className="k">certs/</span>AWS SAA · KCNA · +3
        </span>
        <span className="tag">
          <span className="k">git/</span>
          <a
            className="tag-link"
            href="https://github.com/brysonwaisi"
            target="_blank"
            rel="noreferrer"
          >
            brysonwaisi
            <span className="sr-only"> (opens in new tab)</span>
          </a>
        </span>
        <span className="tag">
          <span className="k">www/</span>
          <a
            className="tag-link"
            href="https://www.nyamwangeb.com/"
            target="_blank"
            rel="noreferrer"
          >
            nyamwangeb.com
            <span className="sr-only"> (opens in new tab)</span>
          </a>
        </span>
      </div>

      <div className="kpis">
        {KPIS.map((k) => (
          <div className="kpi" key={k.k}>
            <div className="k">{k.k}</div>
            <div className="v">
              {k.v}
              <small>{k.unit}</small>
            </div>
            <div className="sub">{renderSub(k.sub)}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
